<template>
  <DynamicModal
    :showModal="showModal"
    :title="title"
    :toolbarColor="toolbarColor"
    :dialogSize="dialogSize"
    maxWidth="800px"
  >
    <template v-slot:content>
      <div class="title py-3">
        {{ contentText }}
      </div>
    </template>
    <template v-slot:buttons>
      <div class="flex-grow-1"></div>
      <v-btn text :disabled="loading" @click="handleCancel">{{ cancelText }}</v-btn>
      <v-btn text color="primary" :loading="loading" @click="handleOk">{{ okText }}</v-btn>
    </template>
  </DynamicModal>
</template>

<script>
import DynamicModal from './DynamicModal'

export default {
  components: {
    DynamicModal
  },
  props: {
    title: String,
    dialogSize: {
      type: String,
      default: '500'
    },
    toolbarColor: {
      type: String,
      default: 'warning'
    },
    contentText: String,
    showModal: Boolean,
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    okText: {
      type: String,
      default: 'Confirm'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel () {
      this.$emit('cancel-click')
    },
    handleOk () {
      this.$emit('ok-click')
    }
  }

}
</script>

<style>

</style>
